import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import AnchorLink from "react-anchor-link-smooth-scroll";

export default function TopNavComponent() {
  const [mobileNav, setMobileNav] = useState(false);
  console.log(mobileNav);
  return (
    <div className="top-nav">
      <Link className="top-nav-left" to="/">
        <img
          alt="cat's taste"
          className="top-nav-logo"
          src="/assets/icons/logo-title.svg"
        />
      </Link>
      <div className="top-nav-right">
        <a className="top-nav-item-grid" href="/">
          <img
            alt="cat's taste"
            className="top-nav-cat-face"
            src="/assets/icons/cat-face-icon.svg"
          />
          <div className="top-nav-item">HOME</div>
        </a>
        <a className="top-nav-item-grid" href="/#our-value">
          <img
            alt="cat's taste"
            className="top-nav-cat-face"
            src="/assets/icons/cat-face-icon.svg"
          />
          <div className="top-nav-item">OUR VALUE</div>
        </a>
        <a className="top-nav-item-grid" href="/#about-us">
          <img
            alt="cat's taste"
            className="top-nav-cat-face"
            src="/assets/icons/cat-face-icon.svg"
          />
          <div className="top-nav-item">ABOUT US</div>
        </a>
        <a className="top-nav-item-grid" href="/product">
          <img
            alt="cat's taste"
            className="top-nav-cat-face"
            src="/assets/icons/cat-face-icon.svg"
          />
          <div className="top-nav-item">PRODUCTS</div>
        </a>
        {/* <div className="top-nav-item-grid">
          <img alt="cat's taste" className="top-nav-cat-face" src="/assets/icons/cat-face-icon.svg" />
          <div className="dropdown-grid">
            <div className="top-nav-item">PRODUCTS</div>
            <img alt="cat's taste" src="/assets/icons/dropdown.svg" />
          </div>
          <div className="dropdown" id="dropdown">
            <a href="product#tasty" className="dropdown-item" to="/product">
              Tasty
            </a>
            <a href="product#healthy-tasty" className="dropdown-item" to="/product">
              Healthy Tasty
            </a>
          </div>
        </div> */}
      </div>
      {/* <div className="hamburger-icon" onClick={() => setMobileNav(!mobileNav)}>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
        <div className="hamburger-line"></div>
      </div> */}
    </div>
  );
}
